import { render } from "./Header.vue?vue&type=template&id=4f89ac52&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=4f89ac52&scoped=true&lang=css"

import exportComponent from "/Users/elschubi/_development/_vue/projects/faszl-gfk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f89ac52"]])

export default __exports__